import type z from '@/lib/zod';
import { toKnownSubTab, toLegacySubTab } from '@/lib/helpers/list-tabs';
import { NOTIFICATION_TABS } from '@/pages/admin-notifications/lib/admin-notifications-filters';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/**
 * Filtri della lista notifiche, validati dal layout una volta per lista e
 * pannelli: uno schema più stretto sul dettaglio scarterebbe i filtri al
 * ritorno in lista.
 */
export const adminNotificationsSearchSchema = commonSearchSchema
  .extend({
    /** Tab della lista (Tutte / Bozze / Programmate / Inviate / Annullate). */
    subTab: optionalSearchString(),
    /**
     * Link di prima con il filtro di stato (`?status=SCHEDULED`): diventa
     * `subTab` e non esce dallo schema. Da rimuovere dopo il 2026-12-31.
     */
    status: optionalSearchString(),
  })
  .transform(({ status, ...search }) => ({
    ...search,
    // Un tab sconosciuto diventa «nessuno»: la lista apre quello di default
    // e la barra lo mostra acceso.
    subTab: toKnownSubTab(
      NOTIFICATION_TABS,
      toLegacySubTab({
        tabs: NOTIFICATION_TABS,
        subTab: search.subTab,
        legacyFilter: status,
      })
    ),
  }));

export type AdminNotificationsSearch = z.output<
  typeof adminNotificationsSearchSchema
>;
